"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _ColorScale = _interopRequireDefault(require("../ColorScale.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Table = function Table(props) {
  var data = props.data,
    _props$getValueText = props.getValueText,
    getValueText = _props$getValueText === void 0 ? function (value, legend) {
      return value.toString();
    } : _props$getValueText;
  var styles = (0, _ColorScale.default)(data, getValueText);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: data.map(function (item, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-ColorScale__table-item'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-ColorScale__table-item__value'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              color: item.color
            },
            children: getValueText(item.value, item.legendText)
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-ColorScale__table-item__scale'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-ColorScale__line'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-ColorScale__line__part'](item.value, item.color)
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-ColorScale__table-item__legend'],
          children: item.legendText
        })]
      }, "table--".concat(index, "--item"));
    })
  });
};
exports.Table = Table;